module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginationOptions !== undefined && _vm.paginationOptions.total) ? _c('div', {
    staticClass: "pagination"
  }, [_c('ul', {
    staticClass: "pagination__list"
  }, [_c('i', {
    staticClass: "pagination__btn_prev icon ion-ios-arrow-back",
    on: {
      "click": _vm.previousPage
    }
  }), _vm._v(" "), _vm._l((_vm.paginationOptions.total), function(page) {
    return _c('li', {
      staticClass: "pagination__item",
      on: {
        "click": function($event) {
          _vm.selectPage(page)
        }
      }
    }, [_c('a', {
      staticClass: "pagination__link",
      class: {
        ' pagination__link_active': page == _vm.paginationOptions.current
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginationOptions.total > 3),
      expression: "paginationOptions.total > 3"
    }],
    staticClass: "pagination__item"
  }, [_c('a', {
    staticClass: "pagination__link"
  }, [_vm._v("...")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginationOptions.total > 5),
      expression: "paginationOptions.total > 5"
    }],
    staticClass: "pagination__item"
  }, [_c('a', {
    staticClass: "pagination__link"
  }, [_vm._v(_vm._s(_vm.paginationOptions.total))])]), _vm._v(" "), _c('i', {
    staticClass: "pagination__btn_next icon ion-ios-arrow-forward",
    on: {
      "click": _vm.nextPage
    }
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-364a9b5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 603
// module chunks = 0